import { useTranslation } from 'react-i18next';
import { useModal } from '@ebay/nice-modal-react';

// Import components
import { MoreInfoButton } from 'components/views/offer_configurator/components/common';
import { ChannelsModal } from 'components/elements/molecules/ChannelsModal/ChannelsModal';

// Import styles
import { Wrapper, Title, SubtitleWrapper, Subtitle } from './styles';

// Import types
import type { PacketChannel } from 'types/api/products/packet/products';

type Props = {
	isShort: boolean;
	title: string;
	isSmallTitle?: boolean;
	channels: PacketChannel[];
};

const PacketDetails = ({ isShort, title, isSmallTitle = false, channels }: Props) => {
	const { t } = useTranslation('configurator');

	const modal = useModal(ChannelsModal);

	const openModal = () => modal.show({ channels, title: t('modal_packet_channels_title', { title }) });

	return (
		<Wrapper isShort={isShort}>
			<Title isSmallTitle={isSmallTitle}>{title}</Title>
			<SubtitleWrapper>
				<Subtitle>{t('channels_count', { count: channels.length })}</Subtitle>

				<MoreInfoButton onClick={openModal} />
			</SubtitleWrapper>
		</Wrapper>
	);
};

export default PacketDetails;
